import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectChecklistTooltipPipe } from '@portal-core/project-checklists/pipes/project-checklist-tooltip/project-checklist-tooltip.pipe';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ProjectChecklistTooltipPipe
  ],
  exports: [
    ProjectChecklistTooltipPipe
  ]
})
export class ProjectChecklistTooltipModule { }
